import { render, staticRenderFns } from "./savings_redeem_record.vue?vue&type=template&id=32b237e0&scoped=true"
import script from "./savings_redeem_record.vue?vue&type=script&lang=js"
export * from "./savings_redeem_record.vue?vue&type=script&lang=js"
import style0 from "./savings_redeem_record.vue?vue&type=style&index=0&id=32b237e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b237e0",
  null
  
)

export default component.exports